export default {
      id: "ic_newsletter-usage",
      viewBox: "0 0 20 20",
      url: "../dist/images/" + "sprite.svg#ic_newsletter-usage",
      toString: function () {
        return this.url;
      }
    }